module.exports = __webpack_public_path__ + "img/palacio-de-la-virreina.fde0d970.jpg";